module.exports = __webpack_public_path__ + "static/media/human_register.35edc2b3.webp";